import Footer from 'ui/snippets/footer/Footer';
import TopRow from 'ui/snippets/topBar/TopBar';

import Container from './Container';
import Content from './Content';
import MainArea from './MainArea';
import MainColumn from './MainColumn';
import SideBar from './SideBar';
import SearchSection from './SearchSection'

export {
  Container,
  Content,
  MainArea,
  SideBar,
  MainColumn,
  Footer,
  TopRow,
  SearchSection
};

// Container
//    TopRow
//    MainArea
//       SideBar
//       MainColumn
//          Content
//    Footer
